
import { communicareMedicationService } from "../../services/communicare/MedicationsApi";
import { logger } from "../common/logger";
import { createEncounter } from "./createEncounter";

export const resetDraftPerformedOn=async (authoringSystem:string,authoringSystemForeignKey:string, isOnboarding:boolean)=>{
    //Call the reset-draft-performed-on endpoint to reset the performed on date if patient is onboading
    if(isOnboarding){
        try {
            var encounter=await createEncounter(authoringSystem,authoringSystemForeignKey)
            await  communicareMedicationService.resetDraftPerformedOn(encounter.authoringSystem,encounter.authoringSystemForeignKey)
        } catch (error) {
            logger.log(error)
        }
    }
}